// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCZJNm1lsIMxyjj-24aUdUWrBbveegKfZI",
  authDomain: "carscrapping-2225c.firebaseapp.com",
  projectId: "carscrapping-2225c",
  storageBucket: "carscrapping-2225c.firebasestorage.app",
  messagingSenderId: "1042185508137",
  appId: "1:1042185508137:web:cab77739e9ca3ce20b9338",
  measurementId: "G-V2S0ZCWRR7"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app, 'us-central1');
// Firestore ya no se usa desde el frontend — todo pasa por Cloud Functions
// (onCall) contra Neon/Postgres. Firebase Auth sigue siendo el identity
// provider, y 'functions' es la capa de API.
export { auth, functions };
